import { ReactNode } from "react";
import { dataColumn } from "../Generic/DataTable";

/** A titled block of form rows, drawn the way the Mailboxes editor draws its sections. */
export function Section({ title, children }: { title: string; children: ReactNode }) {
    return (
        <>
            <div className="subHeaderWithLine">
                <div className="subCol1">{title} &nbsp;</div>
                <div className="subCol2">
                    <hr />
                </div>
            </div>
            <div className="customPaddingSubHeader">{children}</div>
        </>
    );
}

/** A plain, unsortable DataTable column. */
export function column<T>(key: string, title: string, width: string, getData: (row: T) => string): dataColumn<T> {
    return {
        title: <>{title}</>,
        key,
        getData,
        width,
        minWidth: "60px",
        canResize: false,
        sort: undefined,
        textAlignment: "left",
    };
}

/**
 * `.topSection :nth-child(2)` in Main/index.css pads every second child in the
 * header, which would push the second of two header buttons down. Inline
 * padding wins over it.
 */
export const HEADER_BUTTON_STYLE = { padding: "8px 10px", marginLeft: "6px" };

export const EDITOR_TITLE_STYLE = { marginBottom: "6px", marginTop: "-0px", fontWeight: "bold", fontSize: "12pt" };
